import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export const useSimpleRole = () => {
  const { session } = useAuth();

  const { data: roleData } = useQuery({
    queryKey: ["simple-role", session?.user?.id],
    queryFn: async () => {
      if (!session?.user?.id) {
        console.log("🔍 [SimpleRole] No session");
        return { role: 'standard', isSystemAdmin: false };
      }
      
      console.log("🔍 [SimpleRole] Fetching role for:", session.user.email);
      
      const { data, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', session.user.id)
        .maybeSingle();
      
      if (error) {
        console.error("❌ [SimpleRole] Error:", error);
        return { role: 'standard', isSystemAdmin: false };
      }
      
      const role = data?.role || 'standard';
      const isSystemAdmin = role === 'superuser';
      
      console.log("✅ [SimpleRole] Final result:", { role, isSystemAdmin });
      
      return { role, isSystemAdmin };
    },
    enabled: !!session?.user?.id,
    staleTime: 5 * 60 * 1000, // Cache role for 5 minutes for stability
    refetchOnMount: false, // Prevent unnecessary refetches
    placeholderData: (previousData) => previousData // Keep previous role during token refresh
  });

  return {
    role: roleData?.role || 'standard',
    isSystemAdmin: roleData?.isSystemAdmin || false
  };
};